import React from 'react';
import {Field} from 'redux-form';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {SelectField} from 'components/Fields';

import {required} from 'utils/validators';

import {selectDefaultBookingType} from 'ducks/bookings';

const buildBookingTypeOption = bookingType => ({
  value: bookingType.id,
  label: bookingType.name,
  object: bookingType
});

export const initialValue = state => {
  const defaultBookingType = selectDefaultBookingType(state);

  return {
    bookingType:
      defaultBookingType && buildBookingTypeOption(defaultBookingType)
  };
};

const SelectBookingTypeField = ({
  name = 'bookingType',
  bookingTypes,
  onBookingTypeChange
}: any) => (
  <FormField>
    <Label>Booking Type</Label>
    <Field
      name={name}
      component={SelectField}
      validate={[required]}
      options={bookingTypes.map(buildBookingTypeOption)}
      onChange={onBookingTypeChange}
    />
  </FormField>
);

export default SelectBookingTypeField;
